import { useRef, useState } from "react";
import { toast } from "react-toastify";
import EventFormRequest from "./EventFormRequest";
import FormTickets from "./_FormTickets";
import { useParams } from "react-router-dom";
import './_FormTable.css'; // Ensure shared styles are present

const ListTickets = ({ setIsLoading, getInfoFormEvent, listTickets }) => {
    let params = useParams();
    const [state, setState] = useState({
        modalTicketForm: {
            show: false,
            id: 0,
        },
    });

    const handlerModalTickets = (id = 0) => {
        setState({
            ...state,
            modalTicketForm: {
                ...state.modalTicketForm,
                show: true,
                id: id,
            },
        });
    };

    const handlerConfirmeDeleteTicket = (id) => {
        if (window.confirm("Tem a certeza que deseja eliminar este bilhete?")) {
            handlerDeleteTicket(id)
        }
    }

    const handlerDeleteTicket = async (id) => {
        setIsLoading(true);
        let info = await EventFormRequest.deleteTicket({ id: id, id_events: params.id });
        if (info && info.status) {
            setIsLoading(false);
            toast.success("Bilhete eliminado com sucesso.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            getInfoFormEvent();
        } else {
            toast.error(info.msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        }
        setIsLoading(false);
    }

    const TicketsCards = () => {
        if (!listTickets || listTickets.length === 0) {
            return (
                <div className="col-12">
                    <div className="d-flex flex-column align-items-center justify-content-center p-5 rounded-4 border border-secondary border-opacity-10" style={{ background: 'rgba(255,255,255,0.02)' }}>
                        <i className="fa-solid fa-ticket fs-1 text-muted mb-3 opacity-50"></i>
                        <h4 className="text-white-50">Nenhum bilhete configurado</h4>
                        <p className="text-muted small">Adicione bilhetes para começar a vender.</p>
                    </div>
                </div>
            );
        }

        return listTickets.map((item) => (
            <div className="col-12 col-md-4 mb-4" key={item.id}>
                <div
                    className="campaign-card glass-glow h-100 p-4 border-0 transition-hover position-relative"
                    style={{ borderLeft: `4px solid #ea2c61` }}
                    onClick={() => handlerModalTickets(item.id)}
                    role="button"
                >
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <h3 className="fs-5 fw-bold text-white mb-0 text-truncate pe-2">{item.name}</h3>
                        <div className="bg-white bg-opacity-10 px-2 py-1 rounded-3 small fw-bold text-white text-nowrap">
                            {item.ticketPrice}€
                        </div>
                    </div>

                    <div className="d-flex align-items-center text-muted small mb-3">
                        <i className="fa-solid fa-layer-group me-2 text-white-50"></i>
                        <span className="text-white-50">{item.ticketNumberTotal} disponíveis</span>
                    </div>


                    {item.description && (
                        <p className="text-muted small mb-0 line-clamp-2" style={{ opacity: 0.7 }}>
                            {item.description}
                        </p>
                    ) || (
                            <p className="text-muted small mb-0 line-clamp-2" style={{ opacity: 0.5, fontStyle: 'italic' }}>
                                Sem descrição
                            </p>
                        )}


                    <div className="mt-3 pt-3 border-top border-white border-opacity-10 d-flex justify-content-between align-items-center">
                        <span className={`badge ${item.status === 'AVAILABLE' ? 'bg-success' : 'bg-secondary'} bg-opacity-25 border border-white border-opacity-10 text-white-50`} style={{ fontSize: '0.7rem' }}>
                            {item.status === 'AVAILABLE' ? 'Disponível' : 'Indisponível'}
                        </span>

                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-link text-danger p-0 small hover-opacity-100 opacity-50 transition-hover"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handlerConfirmeDeleteTicket(item.id);
                                }}
                                title="Eliminar"
                            >
                                <i className="fa-solid fa-trash"></i>
                            </button>
                            <span className="text-primary small fw-bold hover-underline">
                                Editar <i className="fa-solid fa-pencil ms-1"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <>
            <div className="row mb-4 align-items-center">
                <div className="col-md-6">
                    {/* Header can be here if needed */}
                </div>
                <div className="col-md-6 d-flex justify-content-md-end">
                    <button
                        className="btn-action-primary px-4 py-2 small fw-bold shadow-sm d-flex align-items-center gap-2 rounded-3"
                        onClick={() => handlerModalTickets()}
                    >
                        <i className="fa-solid fa-plus"></i>
                        <span>Novo Bilhete</span>
                    </button>
                </div>
            </div>

            <div className="row">
                <TicketsCards />
            </div>

            <FormTickets
                show={state.modalTicketForm.show}
                id={state.modalTicketForm.id}
                id_events={params.id}
                handleModalhide={() => {
                    getInfoFormEvent(); // Refresh list on close
                    setState({
                        ...state,
                        modalTicketForm: {
                            show: false,
                            id: 0,
                        },
                    });
                }}
            />
        </>
    );
};

export default ListTickets;
